import React, { useEffect } from "react";
import { Modal, Spin, Empty } from "antd";
import { getPromotionStatus } from "@/Promotion/PromotionStatusButton";
import { numberformatter } from "$ACTIONS/util";

/*優惠詳情Modal*/
export default function DetailModal(props) {
    const {
        promotionInfo,
        actionBtnHandler,
        isLoading = false,
        isDetailVisible,
        closeDetail,
        from,
    } = props;

    useEffect(() => {
        global.Pushgtagpiwikurl &&
            global.Pushgtagpiwikurl(
                `promotion/${promotionInfo?.promoTitle}`,
                `Promotion Page - ${promotionInfo?.promoTitle}`
            );
        return () => {
            global.Pushgtagpiwikurl &&
                global.Pushgtagpiwikurl("promotion", "Promotion Page");
        };
    }, []);

    // 内容
    const content = promotionInfo?.body || "";

    // 按鈕
    const renderButton = () => {
        if (!promotionInfo || from === "MyPromotion") { //從 My Promotion readyToStart 前來查看詳情，此時不需要顯示 Btn
            return;
        }
        const statusItem = getPromotionStatus(promotionInfo);
        const { type, btnCN, tagCN, tagText, btnText, isDisabled } = statusItem || {};
        if (!statusItem || type === "noAction") {
            return;
        }

        const { campaignData } = promotionInfo || {};
        const readyToStartBonus = numberformatter((campaignData?.participant?.givenAmount || 0), 2, "removeWhenDecimalAllZero");
        
        return (
            <div className="button-box">
                <button
                    data-cn={btnCN || tagCN}
                    disabled={isDisabled}
                    onClick={() => {actionBtnHandler(promotionInfo, type)}}
                >
                    {btnText || tagText}
                </button>
                {(type === "readyToStart") && (
                    <div className='dialogOfBonusAmount'>รับโบนัส <span className='amount'>{readyToStartBonus}</span> บาท ทันที</div>
                )}
            </div>
        );
    };

    return (
        <Modal
            className="theme-modal promotion-modal promotion-detail-modal"
            title="รายละเอียด โปรโมชั่น" //优惠详情
            centered={true}
            footer={false}
            width={1120}
            visible={isDetailVisible}
            onCancel={() => {
                closeDetail();
            }}
            maskClosable={false}
            destroyOnClose={true}
        >
            <Spin
                spinning={isLoading}
                tip="กำลังโหลด..." //载入中...
            >
                <div style={{minHeight: "500px" }}>
                    {content ? (
                        <iframe
                            id="tlc_game_ifame"
                            className="apply-promotion-detail-box"
                            style={{
                                width: "100%",
                                minHeight: "500px",
                                border: "none",
                            }}
                            srcDoc={
                                "<style>html,body{margin:0;padding:0;}body{padding:15px;}</style>" +
                                content.replace(/<a\s+([^>]*?)>/gi, (_, attrs) => {
                                    // <-- CXF1-6810 make sure all <a /> with target=_top
                                    const TARGET_TOP = ' target="_top"';
                                    if (attrs) {
                                        if (
                                            attrs.toLowerCase().includes(" target=")
                                        ) {
                                            attrs = attrs.replace(
                                                / target=["']?_blank["']?/gi,
                                                TARGET_TOP
                                            );
                                        } else {
                                            attrs += TARGET_TOP;
                                        }
                                    }
                                    return "<a " + attrs + ">";
                                })
                            }
                        />
                    ) : !isLoading ? (
                        // 空状态占位
                        <div className="empty-state">
                            <Empty
                                image="/th/img/img-no-record.svg"
                                description={
                                    <>
                                        ไม่พยรายละเอียด โปรดติดต่อ{" "}
                                        <span
                                            onClick={() => {
                                                Pushgtagdata(
                                                    "Bonus",
                                                    "Contact CS (Text Link)",
                                                    "Bonus_Empty_C_CS",
                                                );
                                                global.PopUpLiveChat();
                                            }}
                                        >
                                            ฝ่ายบริการลูกค้า
                                        </span>
                                    </>
                                }
                            />
                        </div>
                    ) : null}
                </div>

                {content && renderButton()}
            </Spin>
        </Modal>
    );
}
